export default __webpack_public_path__ + "static/media/mobileTakeAPunt.dba7e990.png";